import React, { useState, useEffect, useCallback } from "react";
import { CancelRequest } from "../../../services/AxiosInstance";
import { useNavigate } from "react-router-dom";
import Pagination from "../../constant/Pagination";
import { connect } from "react-redux";
import TableLoaderEffect from "../../constant/TableLoader";
import DebounceSearchInput from "../../constant/DebounceSearchInput";
import { getDocumentListApi } from "../../../services/DocumentService";
import { StaticSelectInput } from "../../constant/SelectInput";

const DocumentPage = ({ userPermission }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [query, setSearchQuery] = useState("");
  const [filter, setFilter] = useState({ status: "" });
  const [docType, setDocType] = useState("");
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const recordsPage = 25;

  const navigate = useNavigate();

  const fetchData = useCallback(() => {
    CancelRequest();
    setIsLoading(true);
    getDocumentListApi(currentPage, recordsPage, query, filter.status)
      .then((resp) => {
        setData(resp.data.results);
        setDocType(resp.data.results);
        setTotal(resp.data.total);
      })
      .catch((error) => {
        console.error(error.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage, query, filter]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePagination = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handleSelectChange = (name, value) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearchChange = (value) => {
    CancelRequest();
    setSearchQuery(value);
    setCurrentPage(1);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-header">
                <h3 className="mb-0">Document List</h3>
                <div className="table-left-header d-flex align-items-center">
                  <div className="me-3 mt-3">
                    <StaticSelectInput
                      optionsList={[
                        { label: "Pending", value: "pending" },
                        { label: "Approved", value: "approved" },
                        { label: "Reviewed", value: "reviewed" },
                        { label: "Issued", value: "issued" },
                        { label: "Rejected", value: "rejected" },
                      ]}
                      setParentInputValue={handleSelectChange}
                      name="status"
                      isClearable
                      placeholder="Select Status"
                    />
                  </div>
                  <div className="form-group me-3">
                    <DebounceSearchInput
                      handleSearchChange={handleSearchChange}
                    />
                  </div>
                  {userPermission?.create && (
                    <button
                      className="btn btn-primary mx-2"
                      onClick={() => navigate("/add-document")}
                    >
                      Add Document
                    </button>
                  )}
                </div>
              </div>

              <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                <table
                  id="empoloyees-tblwrapper"
                  className="table ItemsCheckboxSec dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Type</th>
                      <th>Keyword</th>
                      <th>Description</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <TableLoaderEffect colLength={5} />
                    ) : (
                      data.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <span
                              className="text-primary fw-bold me-3 c-pointer"
                              onClick={() =>
                                navigate(`/document/${item.id}`)
                              }
                            >
                              {item?.title}
                            </span>
                          </td>
                          <td>{item?.document_type}</td>
                          <td>
                            {item?.tags
                              ?.split(",")
                              .slice(0, 5)
                              .map((tag, idx) => (
                                <span
                                  key={idx}
                                  className="badge light border-0 badge-info badge-sm me-1"
                                >
                                  {tag.trim()}
                                </span>
                              ))}
                          </td>
                          <td><span className="text-wrap">{item?.description}</span></td>
                          <td>
                            {" "}
                            {item?.current_version?.status === "draft" ? (
                              <span className="badge light border-0 badge-secondary badge-sm">
                                Draft
                              </span>
                            ) : item?.current_version?.status === "pending" ? (
                              <span className="badge light border-0 badge-warning badge-sm">
                                Pending
                              </span>
                            ) : item?.current_version?.status === "issued" ? (
                              <span className="badge light border-0 badge-primary badge-sm">
                                Issued
                              </span>
                            ) : item?.current_version?.status === "reviewed" ? (
                              <span className="badge light border-0 badge-info badge-sm">
                                Reviewed
                              </span>
                            ) : item?.current_version?.status === "rejected" ? (
                              <span className="badge light border-0 badge-danger badge-sm">
                                Rejected
                              </span>
                            ) : (
                              <span className="badge light border-0 badge-success badge-sm">
                                Approved
                              </span>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {isLoading ? (
                <div style={{ height: "4rem" }}></div>
              ) : (
                <Pagination
                  currentPage={currentPage}
                  recordsPage={recordsPage}
                  dataLength={total}
                  handlePagination={handlePagination}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  userPermission: state.auth.user?.document_permission,
});
export default connect(mapStateToProps)(DocumentPage);

// import React, { useState, useEffect, useCallback } from "react";
// import { getUserListApi } from "../../../services/UserService";
// import { CancelRequest } from "../../../services/AxiosInstance";
// import { useNavigate } from "react-router-dom";
// import Pagination from "../../constant/Pagination";
// import DocumentAddModal from "./AddDocumentModal";
// import { connect } from "react-redux";
// import TableLoaderEffect from "../../constant/TableLoader";
// import DebounceSearchInput from "../../constant/DebounceSearchInput";
// import { SVGICON } from "../../constant/theme";

// const DocumentPage = ({ userRole }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [data, setData] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);
//   const [filter, setFilter] = useState({
//     query: "",
//     department: "",
//     designation: "",
//   });
//   const [selectedItems, setSelectedItems] = useState([]);
//   const recordsPage = 25;

//   const navigate = useNavigate();

//   const fetchData = useCallback(() => {
//     CancelRequest();
//     setIsLoading(true);
//     getUserListApi(currentPage, recordsPage, filter)
//       .then((resp) => {
//         setData(resp.data.data);
//         setTotal(resp.data.total);
//       })
//       .catch((error) => {
//         console.error(error.response?.data?.message || "Error fetching data");
//       })
//       .finally(() => {
//         setIsLoading(false);
//       });
//   }, [currentPage, filter]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const handlePagination = (page) => {
//     setCurrentPage(page.selected + 1);
//   };

//   const handleSearchChange = (value) => {
//     if (value.length > 0) CancelRequest();
//     setFilter((prev) => ({
//       ...prev,
//       query: value,
//     }));
//     setCurrentPage(1);
//   };

//   const handleAfterCreate = (newData) => {
//     setData((prevData) => [newData, ...prevData]);
//     setTotal((prevTotal) => prevTotal + 1);
//   };

//   const handleSelectAll = () => {
//     if (selectedItems.length === data.length) {
//       setSelectedItems([]);
//     } else {
//       setSelectedItems(data.map((item) => item.id));
//     }
//   };

//   const handleSelectItem = (id) => {
//     setSelectedItems((prev) =>
//       prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
//     );
//   };

//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-xl-12">
//           <div className="card">
//             <div className="card-body p-0">
//               <div className="table-header">
//                 <h3 className="mb-0">Document List</h3>
//                 <div className="table-left-header">
//                   <div className="form-group me-3">
//                     <DebounceSearchInput handleSearchChange={handleSearchChange} />
//                   </div>
//                   <button className="btn btn-primary" onClick={() => navigate("/add-document")}>
//                     Add Document
//                   </button>
//                 </div>
//               </div>

//               <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
//                 <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
//                   <thead>
//                     <tr>
//                       <th>
//                         <input
//                           type="checkbox"
//                           checked={selectedItems.length === data.length && data.length > 0}
//                           onChange={handleSelectAll}
//                         />
//                       </th>
//                       <th>Name</th>
//                       <th>Email</th>
//                       <th>Phone</th>
//                       <th>Designation</th>
//                       <th>Department</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {isLoading ? (
//                       <TableLoaderEffect colLength={9} />
//                     ) : (
//                       data.map((item) => (
//                         <tr key={item.id}>
//                           <td>
//                             <input
//                               type="checkbox"
//                               checked={selectedItems.includes(item.id)}
//                               onChange={() => handleSelectItem(item.id)}
//                             />
//                           </td>
//                           <td>
//                             <span
//                               className="text-primary fw-bold c-pointer"
//                               onClick={() => navigate(`/user/${item.id}`)}
//                             >
//                               {item.first_name} {item.last_name}
//                             </span>
//                             {item.is_hod ? (
//                               <span className="ms-1 text-danger">
//                                 {SVGICON.HODIcon}
//                               </span>
//                             ) : item.is_an_approver ? (
//                               <span className="ms-1 text-success">
//                                 {SVGICON.VerifyIcon}
//                               </span>
//                             ) : null}
//                           </td>
//                           <td>{item.email}</td>
//                           <td>{item.phone_number}</td>
//                           <td>{item.designation.name}</td>
//                           <td>{item.department.name}</td>
//                           <td>
//                             {item.status === "Active" ? (
//                               <span className="badge light border-0 badge-success badge-sm">
//                                 Active
//                               </span>
//                             ) : (
//                               <span className="badge light border-0 badge-danger badge-sm">
//                                 Inactive
//                               </span>
//                             )}
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               {isLoading ? (
//                 <div style={{ height: "4rem" }}></div>
//               ) : (
//                 <Pagination
//                   currentPage={currentPage}
//                   recordsPage={recordsPage}
//                   dataLength={total}
//                   handlePagination={handlePagination}
//                 />
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state) => ({
//   userRole: state.auth.user?.role || "Visitor",
// });
// export default connect(mapStateToProps)(DocumentPage);
